// @flow
// Importing React as a namespace instead of using the default import to get access to the react types.
// https://flow.org/en/docs/react/types/
import * as React from 'react';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

type Props = {
    title: string,
    cardStyle: Object,
    isFetching: boolean,
    total: number,
    onClick: Function,
    icon: React.Node,
};

const style = {
    rightAlign: {
        textAlign: 'right',
    }
};

const DashboardCard = (props: Props) => (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
        <Paper style={props.cardStyle} onClick={props.onClick}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    {props.icon}
                </Grid>
                <Grid item xs={6} style={style.rightAlign}>
                    {
                        props.isFetching &&
                        <CircularProgress color="inherit"/>
                    }
                    {
                        !props.isFetching &&
                        <Typography variant="h4" color="inherit">
                            {props.total}
                        </Typography>
                    }
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6" color="inherit">
                        {props.title}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    </Grid>
);

DashboardCard.defaultProps = {
    isFetching: false,
};

export default DashboardCard;
